import { Component, OnInit, OnDestroy } from '@angular/core'
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
} from '@angular/router'

import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'

@Component({
  selector: 'nga-erp-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit, OnDestroy {
  private isLoading: boolean = false

  constructor(private router: Router) {}

  ngOnInit() {
    const startNavigationStream = this.router.events.filter(event => {
      return event instanceof NavigationStart
    })

    const endNavigationStream = this.router.events.filter(event => {
      return (
        event instanceof NavigationEnd ||
        event instanceof NavigationError ||
        event instanceof NavigationCancel
      )
    })

    startNavigationStream.subscribe(event => {
      this.isLoading = true
      // console.log('isLoading', this.isLoading);
    })

    endNavigationStream.subscribe(event => {
      this.isLoading = false
      // console.log('isLoading', this.isLoading);
    })
  }

  ngOnDestroy() {
    // TODO: unsubcribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/loading/loading.component.ts